<template>
  <div class="mainPageDiv">

    <div class="pageHeader">
      Census Report
    </div>

    <span class="subHeaderFont">A report providing a nationality count for each active Contract</span>
    <p>&nbsp;</p>

    <!-- --------------------------------------------------------- -->
    <!-- ---------------- Data Grid ------------------------------ -->
    <!-- --------------------------------------------------------- -->

    <ApplicationGrid :GridData="gridTime" RowsPerPageText="Census Records" SearchText="Search Census Records:"
      :EnablePaging="false" :EnableSearching="true" :EnableSorting="true" :HeaderArrays="headerArrays"
      :RowsPerPageArray="rowsPerPageArray" :EnableSettings="false" :EnableRecordsInfoDisplay="true">

    </ApplicationGrid>
  </div>
</template>

<script>
import axios from "axios";
import { store } from "../../store/store.js";
import ApplicationGrid from "../../components/dataSupport/ApplicationGrid.vue"


export default {
  data() {
    return {
      store,
      gridTime: { grid: null, time: null },
      rowsPerPageArray: [10, 25, 50, 100, 250],
      headerArrays: [

        { defaultShow: true, rawName: 'contractNumber', displayName: 'Contract Number', hoverText: 'The contract number' },
        { defaultShow: true, rawName: 'countryName', displayName: 'Country', hoverText: 'Nationality' },
        { defaultShow: true, rawName: 'nationalityCount', displayName: 'Count', hoverText: 'Count for each nationality on the contract' }
      ],

    };
  },
  created() {
    this.getCensus();
  },
  computed: {
    UserProfileId() {
      return store.authenticatedUser.userProfileId != null
        ? store.authenticatedUser.userProfileId
        : store.tempUserProfileId;
    },
  },
  components: { ApplicationGrid },

  methods: {

    getCensus() {
      axios
        .get(store.webAPIUrl + "vwCensusReport")
        .then((response) => response.data)
        .then((data) => {
          this.$data.gridTime = { grid: data, time: new Date().getTime() };
          //console.log(data);
        });
    }
  },
};
</script>

<style scoped>
.mainPageDiv {
  margin-top: 0px;
  margin-left: 0px;
  margin-bottom: 0px;
  padding-right: 0px;
  text-align: left;
  width: 100%;
}

.subHeaderFont {
  font-size: 18px;
}

.pageHeader {
  font-size: 24px;
}
</style>
